var map = {
	"./image-carousel.de-CH.json": 1379,
	"./image-carousel.de-DE.json": 1380,
	"./image-carousel.en-CA.json": 1381,
	"./image-carousel.en-GB.json": 1382,
	"./image-carousel.en-IN.json": 1383,
	"./image-carousel.en-ME.json": 1384,
	"./image-carousel.en-US.json": 1385,
	"./image-carousel.es-EM.json": 1386,
	"./image-carousel.es-ES.json": 1387,
	"./image-carousel.fr-BE.json": 1388,
	"./image-carousel.fr-CA.json": 1389,
	"./image-carousel.fr-CH.json": 1390,
	"./image-carousel.nl-BE.json": 1391,
	"./image-carousel.nl-NL.json": 1392,
	"./image-carousel.pl-PL.json": 1393,
	"./image-carousel.pt-BR.json": 1394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1378;